export default __webpack_public_path__ + "static/media/ic_notifications.2cde8181.svg";